<div class="d-flex flex-column gap-3">
  <div class="row g-2 align-items-start align-items-lg-center mb-3">
    <div class="col-12 col-lg">
      <div class="d-flex align-items-center gap-3">
        <div class="entity-section-icon rounded-3 d-inline-flex align-items-center justify-content-center">
          <i class="bi bi-sliders"></i>
        </div>
        <div>
          <div class="entity-section-title fw-bold fs-6">Configure Checklist Weightings</div>
          <div class="text-secondary text-xxs">Set the weighting for each answer option so the final checklist score can be calculated consistently.</div>
        </div>
      </div>
    </div>

    <div class="col-12 col-lg-auto">
      <div class="d-grid d-sm-flex align-items-stretch gap-2">
        <span class="badge rounded-pill bg-light text-dark border d-inline-flex align-items-center px-3">
          {{ total_questions }} questions
        </span>

        <span class="badge rounded-pill bg-light text-dark border d-inline-flex align-items-center px-3">
          {{ total_weight_inputs }} inputs
        </span>

        <button type="button" class="btn entity-assign-btn btn-sm rounded-small fw-semibold px-2 py-1 mt-1"
          :disabled="saving || loading_questions || !has_questions" @click="save_checklist_weightings">
          {{ saving ? 'Saving...' : 'Save Checklist Weightings' }}
        </button>
      </div>
    </div>
  </div>

  <section class="d-flex flex-column gap-3">
    <article v-if="loading_questions" class="bg-white rounded-4 border shadow-sm p-4 text-center">
      <div class="fw-semibold text-xs mb-1">Loading checklist questions...</div>
      <div class="text-secondary text-xxs">Please wait while we load questions and answer options.</div>
    </article>

    <article v-if="!loading_questions && !checklist_questions.length" class="bg-white rounded-4 border shadow-sm p-4 text-center">
      <div class="fw-semibold text-xs mb-1">No checklist questions found</div>
      <div class="text-secondary text-xxs">Add single-select or multi-select questions in Manage Questions first.</div>
    </article>

    <template v-if="!loading_questions && checklist_questions.length">
      <article v-for="(question, index) in checklist_questions" :key="question.id"
        class="bg-white rounded-4 border shadow-sm p-4">
        <div class="fw-bold text-xs mb-3">{{ question.question }}</div>

        <div class="d-flex flex-column gap-2 checklist-option-list">
          <div v-for="option in question.options" :key="option.id"
            class="checklist-option-row">
            <label class="text-secondary text-xs mb-0 checklist-option-label">{{ option.label }}</label>
            <input
              v-model.number="option.weight"
              type="number"
              min="0"
              class="form-control form-control-sm text-xs checklist-weight-input"
              aria-label="Checklist weight"
            />
          </div>
        </div>
      </article>
    </template>
  </section>
</div>
